import { forwardRef } from 'react'
import { CloseIcon } from '$common/icons/close'
import { ErrorMarkIcon } from '$common/icons'
import { SnackbarComponent } from '..'

interface Props {
  text: string
  close: () => unknown
  icon?: JSX.Element
}

export const ErrorSnackbar = forwardRef(function ErrorSnackbar(
  { text, icon, close }: Props,
  ref,
) {
  return (
    <SnackbarComponent
      ref={ref}
      text={text}
      button={<CloseIcon sx={{ color: 'gray' }} />}
      icon={icon}
      color="error.main"
      bgcolor="error.light"
      onClick={close}
    />
  )
})

ErrorSnackbar.defaultProps = {
  icon: <ErrorMarkIcon />,
}
